export default __webpack_public_path__ + "static/media/Register.2ea6a229.webp";